import {
  BackgroundAttribute,
  BackgroundPositionXProp,
  BackgroundPositionYProp,
  BackgroundRepeatProp,
  BackgroundSizeProp,
} from '../../../types/background';

/**
 * 背景模型数据
 */
const IMAGE_POSITION = [
  {
    key: 'left-top',
    backgroundRepeat: 'no-repeat',
    backgroundPositionX: 'left',
    backgroundPositionY: 'top',
    backgroundSize: 'auto',
  },
  {
    key: 'center-top',
    backgroundRepeat: 'no-repeat',
    backgroundPositionX: 'center',
    backgroundPositionY: 'top',
    backgroundSize: 'auto',
  },
  {
    key: 'right-top',
    backgroundRepeat: 'no-repeat',
    backgroundPositionX: 'right',
    backgroundPositionY: 'top',
    backgroundSize: 'auto',
  },
  {
    key: 'left-center',
    backgroundRepeat: 'no-repeat',
    backgroundPositionX: 'left',
    backgroundPositionY: 'center',
    backgroundSize: 'auto',
  },
  {
    key: 'center-center',
    backgroundRepeat: 'no-repeat',
    backgroundPositionX: 'center',
    backgroundPositionY: 'center',
    backgroundSize: 'auto',
  },
  {
    key: 'right-center',
    backgroundRepeat: 'no-repeat',
    backgroundPositionX: 'right',
    backgroundPositionY: 'center',
    backgroundSize: 'auto',
  },
  {
    key: 'left-bottom',
    backgroundRepeat: 'no-repeat',
    backgroundPositionX: 'left',
    backgroundPositionY: 'bottom',
    backgroundSize: 'auto',
  },
  {
    key: 'center-bottom',
    backgroundRepeat: 'no-repeat',
    backgroundPositionX: 'center',
    backgroundPositionY: 'bottom',
    backgroundSize: 'auto',
  },
  {
    key: 'right-bottom',
    backgroundRepeat: 'no-repeat',
    backgroundPositionX: 'right',
    backgroundPositionY: 'bottom',
    backgroundSize: 'auto',
  },
];
// 图片平铺
const IMAGE_PAVING_EFFECT = [
  {
    label: '默认',
    key: 'default',
    backgroundRepeat: 'repeat',
    backgroundPositionX: 'center',
    backgroundPositionY: 'center',
    backgroundSize: 'auto',
  },
  {
    label: '缩放平铺',
    key: 'zoom-tile',
    backgroundRepeat: 'no-repeat',
    backgroundPositionX: 'center',
    backgroundPositionY: 'top',
    backgroundSize: '100%',
  },
  {
    label: '上',
    key: 'top',
    backgroundRepeat: 'repeat-x',
    backgroundPositionX: 'center',
    backgroundPositionY: 'top',
    backgroundSize: 'auto',
  },
  {
    label: '中-横向',
    key: 'in-horizontal',
    backgroundRepeat: 'repeat-x',
    backgroundPositionX: 'center',
    backgroundPositionY: 'center',
    backgroundSize: 'auto',
  },
  {
    label: '下',
    key: 'bottom',
    backgroundRepeat: 'repeat-x',
    backgroundPositionX: 'center',
    backgroundPositionY: 'bottom',
    backgroundSize: 'auto',
  },
  {
    label: '左',
    key: 'left',
    backgroundRepeat: 'repeat-y',
    backgroundPositionX: 'left',
    backgroundPositionY: 'top',
    backgroundSize: 'auto',
  },
  {
    label: '中-纵向',
    key: 'in-vertical',
    backgroundRepeat: 'repeat-y',
    backgroundPositionX: 'center',
    backgroundPositionY: 'top',
    backgroundSize: 'auto',
  },
  {
    label: '右',
    key: 'right',
    backgroundRepeat: 'repeat-y',
    backgroundPositionX: 'right',
    backgroundPositionY: 'top',
    backgroundSize: 'auto',
  },
];
// 图片缩放
const IMAGE_SCALING_STRETCH = [
  {
    backgroundRepeat: 'no-repeat',
    backgroundPositionX: 'left',
    backgroundPositionY: 'center',
    backgroundSize: '100% 100%',
  },
];
// 图片填充
const IMAGE_SCALING_FILL = [
  {
    backgroundRepeat: 'no-repeat',
    backgroundPositionX: 'center',
    backgroundPositionY: 'center',
    backgroundSize: 'cover',
  },
];
// 图片等比
const IMAGE_SCALING_CONTAIN = [
  {
    backgroundRepeat: 'no-repeat',
    backgroundPositionX: 'center',
    backgroundPositionY: 'center',
    backgroundSize: 'contain',
  },
];

const sizeOptions = ['auto', '100%', '100% 100%', 'cover', 'contain'];

const repeatOption = {
  default: 3,
  'zoom-tile': 5,
  top: 11,
  'in-horizontal': 1,
  bottom: 12,
  left: 21,
  'in-vertical': 2,
  right: 22,
  'left-top': 13,
  'center-top': 8,
  'right-top': 14,
  'left-center': 6,
  'center-center': 0,
  'right-center': 7,
  'left-bottom': 15,
  'center-bottom': 9,
  'right-bottom': 16,
};

/**
 * 组合平铺信息
 * @param backgroundRepeat
 * @param backgroundPositionX
 * @param backgroundPositionY
 * @param backgroundSize
 */
const composeRepeatInfo = ({
  backgroundRepeat,
  backgroundPositionX,
  backgroundPositionY,
  backgroundSize,
}: Partial<BackgroundAttribute>) =>
  [backgroundRepeat, backgroundPositionX, backgroundPositionY, backgroundSize].join(',');

/**
 * 解析平铺信息
 * @param repeatInfoComposed
 */
const parseRepeatInfo = (repeatInfoComposed: string) =>
  //backgroundRepeat, backgroundPositionX, backgroundPositionY, backgroundSize
  repeatInfoComposed.split(',') as [
    backgroundRepeat: BackgroundRepeatProp,
    backgroundPositionX: BackgroundPositionXProp,
    backgroundPositionY: BackgroundPositionYProp,
    backgroundSize: BackgroundSizeProp,
  ];

/**
 * 解析图片路径
 * @param backgroundImage
 */
function parseBackgroundImageUrl(backgroundImage: string) {
  let ret = '';
  if (backgroundImage) {
    const found = backgroundImage.match(/url\(\s*['|""]?\s*(\S+)\s*['|""]?\s*\)/);
    if (found && found[1]) {
      ret = found[1];
    }
  }
  return ret;
}
// 解析渐变色
function parseBackgroundImageGradient(backgroundImage: string) {
  let ret = '';
  if (backgroundImage) {
    const found = backgroundImage.match(/linear-gradient\(\s*.+\s*\)/);
    if (found && found[0]) {
      ret = found[0];
    }
  }
  return ret;
}
function concatBackgroundColor(color: string) {
  return /linear-gradient\(/.test(color) ? '' : color;
}
function concatBackgroundImage(imageUrl: string, color: string) {
  return [imageUrl ? 'url(' + imageUrl + ')' : '', /linear-gradient\(/.test(color) ? color : '']
    .filter(function (x) {
      return x;
    })
    .join(',');
}

export default {
  IMAGE_POSITION,
  IMAGE_PAVING_EFFECT,
  IMAGE_SCALING_STRETCH,
  IMAGE_SCALING_FILL,
  IMAGE_SCALING_CONTAIN,
  sizeOptions,
  repeatOption,
  composeRepeatInfo,
  parseRepeatInfo,
  parseBackgroundImageUrl,
  parseBackgroundImageGradient,
  concatBackgroundColor,
  concatBackgroundImage,
};
